// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5912818a","239":"724eefa8","455":"1ff8c1eb"}[chunkId] + ".chunk.js";
};